import React, { useCallback } from 'react'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineShareAltIcon from 'components/Luxkit/Icons/line/LineShareAltIcon'
import * as Analytics from 'analytics/analytics'
import { clientEvent } from 'analytics/snowplow/events'

interface Props extends Omit<React.ComponentProps<typeof TextButton>, 'kind' | 'children'> {}

function ShareWithFriendsButton(props: Props) {
  const { onClick } = props

  const onShareClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(e)
    Analytics.track('client-event', clientEvent('share', 'pressed', 'offer_page', 'interaction'))
  }, [onClick])

  return <TextButton
    kind="tertiary"
    {...props}
    startIcon={<LineShareAltIcon aria-hidden="true" />}
    onClick={onShareClick}
  >
    Share
  </TextButton>
}

export default ShareWithFriendsButton
